module.exports = __webpack_public_path__ + "static/pexels-curtis-adams-3935328-1f129ee810bed8c13065a97865247b74.jpg";